/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckMultiPlatformPhoneExistsModel,
  CheckMultiPlatformPhoneNumberResult,
  CreateMultiPlatformUserModel,
  CreateMultiPlatformUserResult,
  DisplayPlatformLocationCoordinatesResponse,
  DisplayPlatformLocationLogoResponse,
  DisplayPlatformPatientAppHostResponse,
  GetDomainFromPlatformIdParams,
  GetDomainFromPlatformIdResult,
  GetMultiPlatformLocationsByPlatformIdResults,
  GetMultiPlatformLocationsParams,
  GetMultiPlatformLocationsResultPagedResults,
  GetMultiPlatformThemeResult,
  GetMultiPlatformUserPlatformsResults,
  GetPlatformIdFromDomainParams,
  GetPlatformIdFromDomainResult,
  GetPlatformIdFromQrCodeParams,
  GetPlatformIdFromQrCodeResult,
  GetPlatformLocationLogosParams,
  VerifyMultiPlatformLoginModel,
  VerifyMultiPlatformLoginResponse
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Returns public location logos for signup and patient navigation.
 */
export const getPlatformLocationLogos = (
    platformId: string,
    params?: GetPlatformLocationLogosParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlatformLocationLogoResponse[]>(
      {url: `/api/v1/multi-platform/platform/${platformId}/location-logos`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPlatformLocationLogosQueryKey = (platformId: string,
    params?: GetPlatformLocationLogosParams,) => {
    return [
    `/api/v1/multi-platform/platform/${platformId}/location-logos`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPlatformLocationLogosQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationLogos>>, TError = ErrorType<unknown>>(platformId: string,
    params?: GetPlatformLocationLogosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationLogos>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationLogosQueryKey(platformId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationLogos>>> = ({ signal }) => getPlatformLocationLogos(platformId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationLogos>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformLocationLogosQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationLogos>>>
export type GetPlatformLocationLogosQueryError = ErrorType<unknown>


/**
 * @summary Returns public location logos for signup and patient navigation.
 */

export function useGetPlatformLocationLogos<TData = Awaited<ReturnType<typeof getPlatformLocationLogos>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: GetPlatformLocationLogosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationLogos>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformLocationLogosQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Multi-platform user existence check by phone number
 */
export const checkMultiPlatformPhoneNumber = (
    checkMultiPlatformPhoneExistsModel: CheckMultiPlatformPhoneExistsModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<CheckMultiPlatformPhoneNumberResult>(
      {url: `/api/v1/multi-platform/auth/exists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkMultiPlatformPhoneExistsModel, signal
    },
      options);
    }
  


export const getCheckMultiPlatformPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkMultiPlatformPhoneNumber>>, TError,{data: CheckMultiPlatformPhoneExistsModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof checkMultiPlatformPhoneNumber>>, TError,{data: CheckMultiPlatformPhoneExistsModel}, TContext> => {

const mutationKey = ['checkMultiPlatformPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkMultiPlatformPhoneNumber>>, {data: CheckMultiPlatformPhoneExistsModel}> = (props) => {
          const {data} = props ?? {};

          return  checkMultiPlatformPhoneNumber(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CheckMultiPlatformPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof checkMultiPlatformPhoneNumber>>>
    export type CheckMultiPlatformPhoneNumberMutationBody = CheckMultiPlatformPhoneExistsModel
    export type CheckMultiPlatformPhoneNumberMutationError = ErrorType<unknown>

    /**
 * @summary Multi-platform user existence check by phone number
 */
export const useCheckMultiPlatformPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkMultiPlatformPhoneNumber>>, TError,{data: CheckMultiPlatformPhoneExistsModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkMultiPlatformPhoneNumber>>,
        TError,
        {data: CheckMultiPlatformPhoneExistsModel},
        TContext
      > => {
      return useMutation(getCheckMultiPlatformPhoneNumberMutationOptions(options));
    }
    /**
 * @summary Multi-platform user authentication by phone number verification
 */
export const verifyMultiPlatformPhoneNumber = (
    verifyMultiPlatformLoginModel: VerifyMultiPlatformLoginModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<VerifyMultiPlatformLoginResponse>(
      {url: `/api/v1/multi-platform/auth/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyMultiPlatformLoginModel, signal
    },
      options);
    }
  


export const getVerifyMultiPlatformPhoneNumberMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMultiPlatformPhoneNumber>>, TError,{data: VerifyMultiPlatformLoginModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMultiPlatformPhoneNumber>>, TError,{data: VerifyMultiPlatformLoginModel}, TContext> => {

const mutationKey = ['verifyMultiPlatformPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMultiPlatformPhoneNumber>>, {data: VerifyMultiPlatformLoginModel}> = (props) => {
          const {data} = props ?? {};

          return  verifyMultiPlatformPhoneNumber(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyMultiPlatformPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMultiPlatformPhoneNumber>>>
    export type VerifyMultiPlatformPhoneNumberMutationBody = VerifyMultiPlatformLoginModel
    export type VerifyMultiPlatformPhoneNumberMutationError = ErrorType<void>

    /**
 * @summary Multi-platform user authentication by phone number verification
 */
export const useVerifyMultiPlatformPhoneNumber = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMultiPlatformPhoneNumber>>, TError,{data: VerifyMultiPlatformLoginModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyMultiPlatformPhoneNumber>>,
        TError,
        {data: VerifyMultiPlatformLoginModel},
        TContext
      > => {
      return useMutation(getVerifyMultiPlatformPhoneNumberMutationOptions(options));
    }
    /**
 * @summary Search for nearby platform locations by zip code, city name, or platform name.
 */
export const getMultiPlatformLocations = (
    params?: GetMultiPlatformLocationsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetMultiPlatformLocationsResultPagedResults>(
      {url: `/api/v1/multi-platform/locations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMultiPlatformLocationsQueryKey = (params?: GetMultiPlatformLocationsParams,) => {
    return [
    `/api/v1/multi-platform/locations`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetMultiPlatformLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getMultiPlatformLocations>>, TError = ErrorType<void>>(params?: GetMultiPlatformLocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocations>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMultiPlatformLocationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiPlatformLocations>>> = ({ signal }) => getMultiPlatformLocations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMultiPlatformLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMultiPlatformLocations>>>
export type GetMultiPlatformLocationsQueryError = ErrorType<void>


/**
 * @summary Search for nearby platform locations by zip code, city name, or platform name.
 */

export function useGetMultiPlatformLocations<TData = Awaited<ReturnType<typeof getMultiPlatformLocations>>, TError = ErrorType<void>>(
 params?: GetMultiPlatformLocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocations>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMultiPlatformLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Create a new platform user or add existing user to platform
 */
export const createMultiPlatformUser = (
    createMultiPlatformUserModel: CreateMultiPlatformUserModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<CreateMultiPlatformUserResult>(
      {url: `/api/v1/multi-platform/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMultiPlatformUserModel, signal
    },
      options);
    }
  


export const getCreateMultiPlatformUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMultiPlatformUser>>, TError,{data: CreateMultiPlatformUserModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createMultiPlatformUser>>, TError,{data: CreateMultiPlatformUserModel}, TContext> => {

const mutationKey = ['createMultiPlatformUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMultiPlatformUser>>, {data: CreateMultiPlatformUserModel}> = (props) => {
          const {data} = props ?? {};

          return  createMultiPlatformUser(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMultiPlatformUserMutationResult = NonNullable<Awaited<ReturnType<typeof createMultiPlatformUser>>>
    export type CreateMultiPlatformUserMutationBody = CreateMultiPlatformUserModel
    export type CreateMultiPlatformUserMutationError = ErrorType<void>

    /**
 * @summary Create a new platform user or add existing user to platform
 */
export const useCreateMultiPlatformUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMultiPlatformUser>>, TError,{data: CreateMultiPlatformUserModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMultiPlatformUser>>,
        TError,
        {data: CreateMultiPlatformUserModel},
        TContext
      > => {
      return useMutation(getCreateMultiPlatformUserMutationOptions(options));
    }
    /**
 * @summary List out platform information for users that belong to multiple platforms, including relevant
domain and token data.
 */
export const getMultiPlatformUserPlatforms = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetMultiPlatformUserPlatformsResults>(
      {url: `/api/v1/multi-platform/list`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMultiPlatformUserPlatformsQueryKey = () => {
    return [
    `/api/v1/multi-platform/list`
    ] as const;
    }

    
export const getGetMultiPlatformUserPlatformsQueryOptions = <TData = Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMultiPlatformUserPlatformsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>> = ({ signal }) => getMultiPlatformUserPlatforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMultiPlatformUserPlatformsQueryResult = NonNullable<Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>>
export type GetMultiPlatformUserPlatformsQueryError = ErrorType<void>


/**
 * @summary List out platform information for users that belong to multiple platforms, including relevant
domain and token data.
 */

export function useGetMultiPlatformUserPlatforms<TData = Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformUserPlatforms>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMultiPlatformUserPlatformsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve theme information for a given platform. Supports styling for deep linking flows on mobile.
 */
export const getMultiPlatformTheme = (
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetMultiPlatformThemeResult>(
      {url: `/api/v1/multi-platform/platform/${platformId}/theme`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMultiPlatformThemeQueryKey = (platformId: string,) => {
    return [
    `/api/v1/multi-platform/platform/${platformId}/theme`
    ] as const;
    }

    
export const getGetMultiPlatformThemeQueryOptions = <TData = Awaited<ReturnType<typeof getMultiPlatformTheme>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformTheme>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMultiPlatformThemeQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiPlatformTheme>>> = ({ signal }) => getMultiPlatformTheme(platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformTheme>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMultiPlatformThemeQueryResult = NonNullable<Awaited<ReturnType<typeof getMultiPlatformTheme>>>
export type GetMultiPlatformThemeQueryError = ErrorType<void>


/**
 * @summary Retrieve theme information for a given platform. Supports styling for deep linking flows on mobile.
 */

export function useGetMultiPlatformTheme<TData = Awaited<ReturnType<typeof getMultiPlatformTheme>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformTheme>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMultiPlatformThemeQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve location information for a given platform.
 */
export const getMultiPlatformLocationsByPlatformId = (
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetMultiPlatformLocationsByPlatformIdResults>(
      {url: `/api/v1/multi-platform/platform/${platformId}/locations`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMultiPlatformLocationsByPlatformIdQueryKey = (platformId: string,) => {
    return [
    `/api/v1/multi-platform/platform/${platformId}/locations`
    ] as const;
    }

    
export const getGetMultiPlatformLocationsByPlatformIdQueryOptions = <TData = Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMultiPlatformLocationsByPlatformIdQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>> = ({ signal }) => getMultiPlatformLocationsByPlatformId(platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMultiPlatformLocationsByPlatformIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>>
export type GetMultiPlatformLocationsByPlatformIdQueryError = ErrorType<void>


/**
 * @summary Retrieve location information for a given platform.
 */

export function useGetMultiPlatformLocationsByPlatformId<TData = Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocationsByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMultiPlatformLocationsByPlatformIdQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves active branch coordinates for a platform chosen during sign-up, plus the branch nearest the
visitor's approximate CloudFront (IP-derived) position when CloudFront supplies one. The visitor's position
is only used to rank branches; it is never returned or logged.
 */
export const getMultiPlatformLocationCoordinatesByPlatformId = (
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlatformLocationCoordinatesResponse>(
      {url: `/api/v1/multi-platform/platform/${platformId}/location-coordinates`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMultiPlatformLocationCoordinatesByPlatformIdQueryKey = (platformId: string,) => {
    return [
    `/api/v1/multi-platform/platform/${platformId}/location-coordinates`
    ] as const;
    }

    
export const getGetMultiPlatformLocationCoordinatesByPlatformIdQueryOptions = <TData = Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMultiPlatformLocationCoordinatesByPlatformIdQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>> = ({ signal }) => getMultiPlatformLocationCoordinatesByPlatformId(platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMultiPlatformLocationCoordinatesByPlatformIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>>
export type GetMultiPlatformLocationCoordinatesByPlatformIdQueryError = ErrorType<unknown>


/**
 * @summary Retrieves active branch coordinates for a platform chosen during sign-up, plus the branch nearest the
visitor's approximate CloudFront (IP-derived) position when CloudFront supplies one. The visitor's position
is only used to rank branches; it is never returned or logged.
 */

export function useGetMultiPlatformLocationCoordinatesByPlatformId<TData = Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformLocationCoordinatesByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMultiPlatformLocationCoordinatesByPlatformIdQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves the host the patient app calls for a platform, so a signed-out native visitor who picks a practice
can browse it as a guest on the same host signed-in platform switching uses.
 */
export const getMultiPlatformPatientAppHostByPlatformId = (
    platformId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlatformPatientAppHostResponse>(
      {url: `/api/v1/multi-platform/platform/${platformId}/patient-app-host`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMultiPlatformPatientAppHostByPlatformIdQueryKey = (platformId: string,) => {
    return [
    `/api/v1/multi-platform/platform/${platformId}/patient-app-host`
    ] as const;
    }

    
export const getGetMultiPlatformPatientAppHostByPlatformIdQueryOptions = <TData = Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMultiPlatformPatientAppHostByPlatformIdQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>> = ({ signal }) => getMultiPlatformPatientAppHostByPlatformId(platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMultiPlatformPatientAppHostByPlatformIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>>
export type GetMultiPlatformPatientAppHostByPlatformIdQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the host the patient app calls for a platform, so a signed-out native visitor who picks a practice
can browse it as a guest on the same host signed-in platform switching uses.
 */

export function useGetMultiPlatformPatientAppHostByPlatformId<TData = Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMultiPlatformPatientAppHostByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMultiPlatformPatientAppHostByPlatformIdQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Summary of GetPlatformIdFromQrCode
 */
export const getPlatformIdFromQrCode = (
    params?: GetPlatformIdFromQrCodeParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetPlatformIdFromQrCodeResult>(
      {url: `/api/v1/multi-platform/platform/qrcode`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPlatformIdFromQrCodeQueryKey = (params?: GetPlatformIdFromQrCodeParams,) => {
    return [
    `/api/v1/multi-platform/platform/qrcode`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPlatformIdFromQrCodeQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformIdFromQrCode>>, TError = ErrorType<void>>(params?: GetPlatformIdFromQrCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformIdFromQrCode>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformIdFromQrCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformIdFromQrCode>>> = ({ signal }) => getPlatformIdFromQrCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformIdFromQrCode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformIdFromQrCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformIdFromQrCode>>>
export type GetPlatformIdFromQrCodeQueryError = ErrorType<void>


/**
 * @summary Summary of GetPlatformIdFromQrCode
 */

export function useGetPlatformIdFromQrCode<TData = Awaited<ReturnType<typeof getPlatformIdFromQrCode>>, TError = ErrorType<void>>(
 params?: GetPlatformIdFromQrCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformIdFromQrCode>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformIdFromQrCodeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve platformId code from a given domain in the form of sub.domain.[env].app
 */
export const getPlatformIdFromDomain = (
    params?: GetPlatformIdFromDomainParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetPlatformIdFromDomainResult>(
      {url: `/api/v1/multi-platform/platform/domain`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPlatformIdFromDomainQueryKey = (params?: GetPlatformIdFromDomainParams,) => {
    return [
    `/api/v1/multi-platform/platform/domain`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPlatformIdFromDomainQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformIdFromDomain>>, TError = ErrorType<void>>(params?: GetPlatformIdFromDomainParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformIdFromDomain>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformIdFromDomainQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformIdFromDomain>>> = ({ signal }) => getPlatformIdFromDomain(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformIdFromDomain>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformIdFromDomainQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformIdFromDomain>>>
export type GetPlatformIdFromDomainQueryError = ErrorType<void>


/**
 * @summary Retrieve platformId code from a given domain in the form of sub.domain.[env].app
 */

export function useGetPlatformIdFromDomain<TData = Awaited<ReturnType<typeof getPlatformIdFromDomain>>, TError = ErrorType<void>>(
 params?: GetPlatformIdFromDomainParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformIdFromDomain>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformIdFromDomainQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve domain from a given platformId
 */
export const getDomainFromPlatformId = (
    params?: GetDomainFromPlatformIdParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetDomainFromPlatformIdResult>(
      {url: `/api/v1/multi-platform/platform/domain/id`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDomainFromPlatformIdQueryKey = (params?: GetDomainFromPlatformIdParams,) => {
    return [
    `/api/v1/multi-platform/platform/domain/id`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetDomainFromPlatformIdQueryOptions = <TData = Awaited<ReturnType<typeof getDomainFromPlatformId>>, TError = ErrorType<void>>(params?: GetDomainFromPlatformIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainFromPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDomainFromPlatformIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomainFromPlatformId>>> = ({ signal }) => getDomainFromPlatformId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDomainFromPlatformId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDomainFromPlatformIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDomainFromPlatformId>>>
export type GetDomainFromPlatformIdQueryError = ErrorType<void>


/**
 * @summary Retrieve domain from a given platformId
 */

export function useGetDomainFromPlatformId<TData = Awaited<ReturnType<typeof getDomainFromPlatformId>>, TError = ErrorType<void>>(
 params?: GetDomainFromPlatformIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainFromPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDomainFromPlatformIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




